import { Link } from "@tanstack/react-router";
import logoSrc from "@/assets/favicon_io/android-chrome-192x192.png";

type PublicLayoutProps = {
  children: React.ReactNode;
};

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-svh bg-background">
      <header className="sticky top-0 z-10 border-b bg-background/95 backdrop-blur supports-backdrop-filter:bg-background/80">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
          <Link
            to="/development"
            className="flex items-center gap-2.5 font-semibold text-foreground"
          >
            <img
              src={logoSrc}
              alt="PARTZYNC"
              width={32}
              height={32}
              className="h-8 w-8 object-contain"
            />
            <span className="hidden sm:inline">PARTZYNC</span>
          </Link>
          <Link
            to="/auth/login"
            className="text-muted-foreground text-sm transition-colors hover:text-foreground"
          >
            ເຂົ້າສູ່ລະບົບ Admin
          </Link>
        </div>
      </header>
      <main>{children}</main>
      <footer className="border-t py-6">
        <p className="text-center text-muted-foreground text-xs">
          PARTZYNC Platform — ສະຖານະການພັດທະນາ (Public)
        </p>
      </footer>
    </div>
  );
}
